module.exports = "<h1>Thank you!</h1>\n<p>We received your order and will process it within the next 24 hours!</p>"


//////////////////
// WEBPACK FOOTER
// D:/xampp_bk/htdocs/xampp/organicshop/src/app/shopping/components/order-success/order-success.component.html
// module id = ../../../../../src/app/shopping/components/order-success/order-success.component.html
// module chunks = 1